module.exports = __webpack_public_path__ + "static/media/Week 1 Friday.29ea95e6.png";